import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import PrivateMessage from "./views/PrivateMessage.vue";
import Profile from "./views/Profile.vue";
import About from "./views/About.vue";
import Share from "./views/Share.vue";
import ViewPrivateMessage from "@/views/ViewPrivateMessage";
import AnonymousMessage from "@/views/AnonymousMessage";
import SafeNote from "@/views/SafeNote";

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: SafeNote,
        footer: AppFooter
      }
    },
    {
      path: "/private-message",
      name: "private-message",
      components: {
        header: AppHeader,
        default: PrivateMessage,
        footer: AppFooter
      }
    },
    {
      path: "/anonymous-message",
      name: "anonymous-message",
      components: {
        header: AppHeader,
        default: AnonymousMessage,
        footer: AppFooter
      }
    },
    {
      path: "/share/:hash",
      name: "share",
      components: {
        header: AppHeader,
        default: Share,
        footer: AppFooter
      }
    },
    {
      path: "/p/:hash",
      name: "viewpm",
      components: {
        header: AppHeader,
        default: ViewPrivateMessage,
        footer: AppFooter
      }
    },
    {
      path: "/components",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    {
      path: "/about",
      name: "about",
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      }
    }

  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
